import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Grid } from '@material-ui/core';
import { useLayoutFormHeaderContainerStyles } from './LayoutFormHeader.styles';

export const LayoutFormHeader = memo(() => {
    const { t } = useTranslation();
    const { logoImage, headerContainer, plusImage } = useLayoutFormHeaderContainerStyles();

    const plusImageSrc = `${process.env.PUBLIC_URL}/assets/landing2020/plus.png`;
    const signaturitLogoSrc = `${process.env.PUBLIC_URL}/assets/images/logo.svg`;

    const logoAlt = t('auth.form_layout_header.logo_alt');
    const plusImageAlt = t('auth.form_layout_header.plus_image_alt');

    return (
        <Grid data-signa="auth-layout-form-header-container" className={headerContainer} container>
            <Grid>
                <img
                    data-signa="auth-layout-form-header-signaturit-logo"
                    className={logoImage}
                    src={signaturitLogoSrc}
                    alt={logoAlt}
                />
            </Grid>

            <Grid>
                <img
                    data-signa="auth-layout-form-header-image-plus"
                    className={plusImage}
                    src={plusImageSrc}
                    alt={plusImageAlt}
                />
            </Grid>
        </Grid>
    );
});
